const CONSTANTS = {
  // Hash actions
  MENU_OPEN: '#menu-open',
  MODAL_OPEN_OFFER: '#modal-open_offer',

  ACCOUNT_DROPDOWN: 'ACCOUNT_DROPDOWN',
  MY_ZONE_DROPDOWN: 'MY_ZONE_DROPDOWN',
  CATEGORIES_DROPDOWN: 'CATEGORIES_DROPDOWN',
  MOCK_MORE_DROPDOWN: 'MOCK_MORE_DROPDOWN',
  CASH_BALANCE: 'CASH_BALANCE',
  DREAM_BALANCE: 'DREAM_BALANCE',
  LANGUAGE_SWITCH: 'LANGUAGE_SWITCH',
  SIGN_IN_BUTTON: 'SIGN_IN_BUTTON',
  SIGN_OUT_BUTTON: 'SIGN_OUT_BUTTON',
  PRIMARY_BUTTON_BLUE: 'PRIMARY_BUTTON_BLUE',
  ACTIVE_LINK: 'ACTIVE_LINK',
  OFFERS: 'Offers',
  SHOPS: 'Shops',
  GRID: 'Grid',
  CAROUSEL: 'Carousel',
  CATEGORIES: 'Categories',
  SUBCATEGORY_DELIMITER: '-_-',
  TIER_BLUE: 'Blue',
  TIER_GOLD: 'Gold',
  TIER_ONYX: 'Onyx',
  DESKTOP_ONLY: 'DESKTOP_ONLY',
  MOBILE_ONLY: 'MOBILE_ONLY',

  // Analytics (Data Layer)
  DL_SHOPS: 'Shops',
  DL_OFFERS: 'Offers',
  DL_LIFE_STYLE_BANNER: 'Lifestyle Banner',
  DL_AD_BANNER: 'Ad Banner',
  DL_SMALL_PROMO_BANNER: 'Small Promo Banner',
  DATA_TRACK_ROLE_CONTAINER: 'Container',
  DL_COLLECTOR_NUMBER: 'collectorNumber',
  DL_VIRTUAL_PAGE: 'sendVirtualPage',
  DL_SEND_OFFER_VIEW: 'sendOfferView',
  DL_PAGE_NAME_MODAL_SIGN_IN: 'modal_sign-in',
  DL_PAGE_NAME_MODAL_ONBOARDING: 'modal_onboarding',
  DL_PAGE_NAME_MODAL_OFFER: 'modal_offer',
  DL_SPLASH_PAGE_SHOP: 'splash_page_shop',
  DL_SPLASH_PAGE_OFFER: 'splash_page_offer',

  // Currencies
  CAD: 'CAD',
  USD: 'USD',

  // Data track values
  MOCK_ANALYTICS_PAGE_INTERACTION: 'on-page-interaction',
  DATA_TRACK_TYPE_CTA: 'cta',
  DATA_TRACK_TYPE_BANNER: 'banner',
  DATA_TRACK_TYPE_INTERNAL: 'internal',
  DATA_TRACK_CLICK_SHOP: 'click-shop',
  DATA_TRACK_CLICK_HERO_BANNER_SECTION: 'hero-banner-section',
  DATA_TRACK_CLICK_BANNER_SECTION: 'banner-section',
  DATA_TRACK_CLICK_NOTIFICATION_SECTION: 'notification-section',

  // DOM ids
  DOM_SHOP_CARD: 'shop-card',
  DOM_OFFER_CARD: 'offer-card',
  DOM_PRIMARY_LINK: 'primary-link',
  DOM_SECONDARY_LINK: 'secondary-link',
  DOM_SEARCH_NAV_SLOT: 'search-nav-slot',
  DOM_CATEGORIES_NAV_SLOT: 'categories-nav-slot',
  DOM_CATEGORIES_NAV_SLOT_MOBILE: 'categories-nav-slot-mobile',
  DOM_CATEGORIES_NAV_SLOT_SHOP: 'categories-nav-slot-shop',
  DOM_GLOBAL_NAV_SLOT: 'global-nav-slot',
  DOM_CATEGORIES_BOTTOM_LINK: 'categories-bottom-link',
  DOM_BUTTON: 'button',
  DOM_CAROUSEL: 'carousel',
  DOM_ACCORDION: 'accordion',
  DOM_GREETING_SECTION: 'greeting-section',
  DOM_MY_ZONE_DROPDOWN: 'my-zone-dropdown',
  DOM_LAYOUT_LIFESTYLE_BANNER: 'layout-lifestyle-banner',
  DOM_TITLED_SECTION: 'titled-section',
  DOM_FOOTER: 'footer',
  DOM_AD_SMALL: 'ad-small',
  DOM_AD_LARGE: 'ad-large',
  DOM_LAYOUT_HERO_BANNER: 'layout-hero-banner',
  DOM_GLOBAL_BANNER: 'global-banner',
  DOM_SEARCH_BAR: 'search-bar',
  DOM_OFFER_MODAL: 'offer-modal',
  DOM_MODAL: 'modal',
  DOM_SIGN_IN_MODAL: 'modal',
  DOM_SEARCH_RESULTS_EMPTY_STATE: 'search-results-empty-state',
  DOM_SHOP_CARD_INFO: 'shop-card-info',
  DOM_SEARCH_RESULTS: 'search-results',
  DOM_SHOP_DETAILS: 'shop-details',
  DOM_INTERSTITIAL_PAGE: 'interstitial-page',
  DOM_MY_ZONE_PAGE: 'my-zone-page',
  DOM_NOT_FOUND_PAGE: 'page404',
  DOM_HOW_IT_WORKS_INFO_SECTION: 'how-it-works-info-section',
  DOM_HEADER_SECTION: 'header-section',
  DOM_ONBOARDING_MODAL: 'onboarding-modal',
  DOM_LAYOUT_SMALL_PROMO_BANNER: 'layout-small-promo-banner',
  DOM_CATEGORY_DIRECTORY: 'category-directory',
  DOM_SITEMAP_CATEGORY_SECTION: 'sitemap-category-section',
  DOM_SITEMAP_SHOP_SECTION: 'sitemap-shop-section',
  DOM_SITEMAP_LINKS_SECTION: 'sitemap-links-section',
  DOM_NOTIFICATION_BANNER: 'notification-banner',

  // Page names (Used for indexing for Algolia)
  PAGE_HOME: 'home',
  PAGE_SEARCH: 'search',
  PAGE_CATEGORY: 'category',

  // Algolia items per page
  ALGOLIA_HITS_PER_PAGE: 5000,
  ALGOLIA_MAX_FACETS_HITS: 100,

  // Key values
  ENTER_KEY: 'Enter',

  // Timeout
  INTERSTITIAL_TIMEOUT: Number(process.env.INTERSTITIAL_TIMEOUT) || 3000,
  INTERRUPT_CHECK_DAYS: Number(process.env.INTERRUPT_CHECK_DAYS) || 30,
  RESIZE_TIMOUT: 50,

  // Messages
  UNSUCESSFUL_SIGN_IN_MESSAGE_DEFAULT: 'Oops, something went wrong. Please try again',

  // My Zone Slug Constants
  MY_ZONE_OFFERS_PAGE: 'offers',
  MY_ZONE_SHOPS_PAGE: 'shops',
  MY_ZONE_SIGN_OUT: 'signout',

  // Directory Tab Slug Constants
  STORE_DIRECTORY_SLUG: 'shops',
  CATEGORIES_DIRECTORY_SLUG: 'categories',

  // Category Tab Constants
  CATEGORY_PAGE_SHOPS: 'shops',
  CATEGORY_PAGE_OFFERS: 'offers',

  // Search Facets
  FACET_CATEGORIES: 'categories',

  // Offers
  OFFERS_LAYOUT_LOAD_INCREMENT: Number(process.env.OFFERS_LAYOUT_LOAD_INCREMENT) || 200,

  // Components
  COMPONENT_PAGE_BODY: 'PageBody',
  COMPONENT_NAVIGATION_SEARCH_BAR: 'NavigationSearchBar',
  COMPONENT_NAVIGATION_CATEGORIES_BAR: 'NavigationCategoriesBar',

  // Site Map Section Slugs
  SITE_MAP_MAIN_LINKS_SECTION: 'sitemap-main-links-section',
  SITE_MAP_ADDITIONAL_LINKS_SECTION: 'sitemap-additional-links-section',
  SITE_MAP_STORES_SECTION: 'sitemap-stores-section',
  SITE_MAP_CATEGORIES_SECTION: 'sitemap-categories-section',

  // Directory
  PAGE_DIRECTORY: 'directory',

  PAGE_MY_ZONE: 'my_zone',
  PAGE_SPECIAL_OFFERS: 'special_offers',

  // Pinterest
  PINTEREST_ACCOUNT_USER: process.env.PINTEREST_ACCOUNT_USER || 'storabi@loyalty.com',
  PINTEREST_TAG: process.env.PINTEREST_TAG || '2612927279817',

  // Session
  SESSION_MAX_LENGTH: Number(process.env.SESSION_MAX_LENGTH) || 30 * 60 * 1000, // 30 mins
  SESSION_REFRESH_THRESHOLD: Number(process.env.SESSION_REFRESH_THRESHOLD) || 0.2,
  SESSION_EXTENSION_DELAY: 1000,
  SESSION_EXTENSION_DELTA_MILLIS: Number(process.env.SESSION_EXTENSION_DELTA_MILLIS) || 60000,
  SESSION_AUTH_EXPIRY: 'authExpiry',
  AUTH_SESSION_COOKIE_NAME: 'auth-session',

  // Authentication
  M2M_CACHE_KEY: 'server-access-token',
  M2M_CACHE_TTL: 60 * 60,
  NODE_CACHE_CHECK_PERIOD: 30,
  SSO_SILENT_SKIP_COOKIE: 'sso_silent_skip',
  SSO_SILENT_NONCE_COOKIE: 'sso_silent_nonce',
  SSO_SILENT_ATTEMPT_COOKIE: 'sso_silent_attempt',
  SSO_SILENT_SKIP_MAX_AGE: 30 * 1000,
  SSO_SILENT_NONCE_MAX_AGE: 2 * 60 * 1000,
  SSO_SILENT_ATTEMPT_MAX_AGE: 60 * 1000,
  SSO_STATE_TTL_SECONDS: 2 * 60,

  // Cookie Settings
  COOKIE_SECURE: process.env.COOKIE_SECURE !== undefined
    ? Number(process.env.COOKIE_SECURE)
    : 1,
  COOKIE_HTTP_ONLY: Number(process.env.COOKIE_HTTP_ONLY) || 0,

  // Site Settings
  BASE_SITE_URL: process.env.NEXT_PUBLIC_BASE_SITE_URL || 'http://localhost:8081',

  // Extension Settings
  EXTENSION_REDIRECT_COOKIE_PREFIX: 'shops-extension-redirects',

};

export default CONSTANTS;
export const {
  MENU_OPEN,
  MODAL_OPEN_OFFER,
  ACCOUNT_DROPDOWN,
  MY_ZONE_DROPDOWN,
  CATEGORIES_DROPDOWN,
  MOCK_MORE_DROPDOWN,
  CASH_BALANCE,
  DREAM_BALANCE,
  LANGUAGE_SWITCH,
  SIGN_IN_BUTTON,
  SIGN_OUT_BUTTON,
  PRIMARY_BUTTON_BLUE,
  ACTIVE_LINK,
  OFFERS,
  SHOPS,
  GRID,
  CAROUSEL,
  CATEGORIES,
  SUBCATEGORY_DELIMITER,
  TIER_BLUE,
  TIER_GOLD,
  TIER_ONYX,
  DESKTOP_ONLY,
  MOBILE_ONLY,
  DL_SHOPS,
  DL_OFFERS,
  DL_LIFE_STYLE_BANNER,
  DL_AD_BANNER,
  DL_SMALL_PROMO_BANNER,
  DATA_TRACK_ROLE_CONTAINER,
  DL_COLLECTOR_NUMBER,
  DL_VIRTUAL_PAGE,
  DL_SEND_OFFER_VIEW,
  DL_PAGE_NAME_MODAL_SIGN_IN,
  DL_PAGE_NAME_MODAL_ONBOARDING,
  DL_PAGE_NAME_MODAL_OFFER,
  DL_SPLASH_PAGE_SHOP,
  DL_SPLASH_PAGE_OFFER,
  CAD,
  USD,
  MOCK_ANALYTICS_PAGE_INTERACTION,
  DATA_TRACK_TYPE_CTA,
  DATA_TRACK_TYPE_BANNER,
  DATA_TRACK_TYPE_INTERNAL,
  DATA_TRACK_CLICK_SHOP,
  DATA_TRACK_CLICK_HERO_BANNER_SECTION,
  DATA_TRACK_CLICK_BANNER_SECTION,
  DATA_TRACK_CLICK_NOTIFICATION_SECTION,
  DOM_SHOP_CARD,
  DOM_OFFER_CARD,
  DOM_PRIMARY_LINK,
  DOM_SECONDARY_LINK,
  DOM_SEARCH_NAV_SLOT,
  DOM_CATEGORIES_NAV_SLOT,
  DOM_CATEGORIES_NAV_SLOT_MOBILE,
  DOM_CATEGORIES_NAV_SLOT_SHOP,
  DOM_GLOBAL_NAV_SLOT,
  DOM_CATEGORIES_BOTTOM_LINK,
  DOM_BUTTON,
  DOM_CAROUSEL,
  DOM_ACCORDION,
  DOM_GREETING_SECTION,
  DOM_MY_ZONE_DROPDOWN,
  DOM_LAYOUT_LIFESTYLE_BANNER,
  DOM_TITLED_SECTION,
  DOM_FOOTER,
  DOM_AD_SMALL,
  DOM_AD_LARGE,
  DOM_LAYOUT_HERO_BANNER,
  DOM_GLOBAL_BANNER,
  DOM_SEARCH_BAR,
  DOM_OFFER_MODAL,
  DOM_MODAL,
  DOM_SIGN_IN_MODAL,
  DOM_SEARCH_RESULTS_EMPTY_STATE,
  DOM_SHOP_CARD_INFO,
  DOM_SEARCH_RESULTS,
  DOM_SHOP_DETAILS,
  DOM_INTERSTITIAL_PAGE,
  DOM_MY_ZONE_PAGE,
  DOM_NOT_FOUND_PAGE,
  DOM_HOW_IT_WORKS_INFO_SECTION,
  DOM_HEADER_SECTION,
  DOM_ONBOARDING_MODAL,
  DOM_LAYOUT_SMALL_PROMO_BANNER,
  DOM_CATEGORY_DIRECTORY,
  DOM_SITEMAP_CATEGORY_SECTION,
  DOM_SITEMAP_SHOP_SECTION,
  DOM_SITEMAP_LINKS_SECTION,
  DOM_NOTIFICATION_BANNER,
  PAGE_HOME,
  PAGE_SEARCH,
  PAGE_CATEGORY,
  ALGOLIA_HITS_PER_PAGE,
  ALGOLIA_MAX_FACETS_HITS,
  ENTER_KEY,
  INTERSTITIAL_TIMEOUT,
  INTERRUPT_CHECK_DAYS,
  RESIZE_TIMOUT,
  UNSUCESSFUL_SIGN_IN_MESSAGE_DEFAULT,
  MY_ZONE_OFFERS_PAGE,
  MY_ZONE_SHOPS_PAGE,
  MY_ZONE_SIGN_OUT,
  STORE_DIRECTORY_SLUG,
  CATEGORIES_DIRECTORY_SLUG,
  CATEGORY_PAGE_SHOPS,
  CATEGORY_PAGE_OFFERS,
  FACET_CATEGORIES,
  OFFERS_LAYOUT_LOAD_INCREMENT,
  COMPONENT_PAGE_BODY,
  COMPONENT_NAVIGATION_SEARCH_BAR,
  COMPONENT_NAVIGATION_CATEGORIES_BAR,
  SITE_MAP_MAIN_LINKS_SECTION,
  SITE_MAP_ADDITIONAL_LINKS_SECTION,
  SITE_MAP_STORES_SECTION,
  SITE_MAP_CATEGORIES_SECTION,
  PAGE_DIRECTORY,
  PAGE_MY_ZONE,
  PAGE_SPECIAL_OFFERS,
  PINTEREST_ACCOUNT_USER,
  PINTEREST_TAG,
  SESSION_MAX_LENGTH,
  SESSION_REFRESH_THRESHOLD,
  SESSION_EXTENSION_DELAY,
  SESSION_EXTENSION_DELTA_MILLIS,
  SESSION_AUTH_EXPIRY,
  AUTH_SESSION_COOKIE_NAME,
  M2M_CACHE_KEY,
  M2M_CACHE_TTL,
  NODE_CACHE_CHECK_PERIOD,
  SSO_SILENT_SKIP_COOKIE,
  SSO_SILENT_NONCE_COOKIE,
  SSO_SILENT_ATTEMPT_COOKIE,
  SSO_SILENT_SKIP_MAX_AGE,
  SSO_SILENT_NONCE_MAX_AGE,
  SSO_SILENT_ATTEMPT_MAX_AGE,
  SSO_STATE_TTL_SECONDS,
  COOKIE_SECURE,
  COOKIE_HTTP_ONLY,
  BASE_SITE_URL,
  EXTENSION_REDIRECT_COOKIE_PREFIX,
} = CONSTANTS;
